import "./styles.less";

import { Affix, Col, Row, Space } from "antd";

import { Favorite } from "../../../Components/Property/Favorite/web";
import { FormButton } from "../../../Components/Property/InformationRequest/LeadButtons/FormButton/web";
import { LocationTag } from "../../../Components/Property/LocationTag/web";
import { PriceTag } from "../../../Components/Property/PriceTag/web";
import React from "react";
import { SocialShare } from "../../../Components/Property/SocialShare/web";
import { Title } from "../../../Components/Property/Title/web";
import { getMode, isTemporal } from "../../../Utils/Functions";
import { useTheme } from "../../../Styles/ThemeHook";
import { LeadButtons } from "shared-components/Components/Property/InformationRequest/LeadButtons/web";
import { Listing } from "shared-components";

export const PropertyAffixHeader = ({
	id,
	listing,
	mode = "auto",
}: {
	id: string;
	listing: Listing;
	mode;
}) => {
	const { theme } = useTheme();
	return (
		<Affix className={"pd_affix_top"} offsetTop={theme.headerHeight}>
			<div className="container pd-container">
				<Row className={"pd-affix-row"} gutter={theme.spacing.xlSpacing}>
					<Col span={8}>
						<Title
							level={4}
							hideInformation={true}
							limitLength={1}
							title={listing.title}
						/>
						<LocationTag />
					</Col>
					{!isTemporal(listing.operation_type?.id) && listing?.price ? (
						<Col flex={1}>
							<PriceTag
								price={listing.price}
								priceVariation={listing.price_variation}
								commonExpenses={listing.commonExpenses}
								temporalCurrency={listing.temporal_currency}
								temporalPrice={listing.temporal_price}
								operationType={listing.operation_type}
								isProject={listing.isProject}
								showExpenses={listing.commonExpenses?.amount > 0}
							/>
						</Col>
					) : null}
					<Col>
						<Space size={theme.spacing.lgSpacing}>
							{!listing.isProject && (
								<Favorite id={id} isDisabledProperty={!listing.active} />
							)}
							<SocialShare id={id} mode={mode} isDisabledProperty={!listing.active} />

							<LeadButtons
								id={listing.isProject ? listing.project?.id : listing.legacy_propID}
								mode={getMode(listing.isProject)}
								isInListing
								isProject={listing.isProject}
								projectId={listing.project?.id ?? ""}
								owner={listing.owner}
								seller={listing.seller}
								source="card"
								ctaToShow={{
									contact: true,
									phone: false,
									whatsapp: false
								}}
							/>
						</Space>
					</Col>
				</Row>
			</div>
		</Affix>
	);
};

